<template>
  <v-dialog v-model="show" persistent max-width="400px" no-click-animation>
    <v-card>
      <div
        class="primary mb-4 d-flex align-center position-relative"
        style="height: 80px;"
      >
        <div class="logo-wrapper">
          <div class="logo-frame mx-auto mb-2">
            <img
              alt="Academic Development Institute"
              class="d-block mx-auto pa-4"
              contain
              src="@/assets/adi_logo.png"
              transition="scale-transition"
              width="120px"
            />
          </div>
        </div>
      </div>

      <v-card-title class="mt-12">
        <div class="text-h4 pb-4 flex-fill text-center">Admin Login</div>
      </v-card-title>
      <v-card-text>
        <v-alert
          :value="errorMessage != null"
          color="red"
          dark
          icon="$error"
          transition="scale-transition"
          class="mb-6"
        >
          {{ errorMessage }}
        </v-alert>
        <ValidationObserver
          ref="observer"
          tag="form"
          @submit.prevent="onSubmit"
        >
          <ValidationProvider v-slot="{ errors }" rules="required">
            <v-text-field
              v-model="email"
              outlined
              label="Email"
              name="email"
              class="mb-3"
              :error-messages="errors"
              :disabled="loading"
              autofocus
            ></v-text-field>
          </ValidationProvider>
          <ValidationProvider v-slot="{ errors }" rules="required">
            <v-text-field
              v-model="password"
              outlined
              label="Password"
              type="password"
              name="password"
              class="mb-3"
              :error-messages="errors"
              :disabled="loading"
            ></v-text-field>
          </ValidationProvider>

          <v-btn type="submit" block color="primary" x-large :loading="loading">
            Login
          </v-btn>
        </ValidationObserver>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<style>
.logo-wrapper {
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
}
.logo-frame {
  background: #fff;
  display: inline-block;
  border-top-left-radius: 100%;
  border-top-right-radius: 100%;
  border-bottom-left-radius: 100%;
  border-bottom-right-radius: 100%;
  overflow: hidden;
  border: 3px solid #043654;
}
</style>

<script>
export default {
  data: () => ({
    show: false,
    loading: false,
    email: "",
    password: "",
    errorMessage: null,
  }),
  computed: {
    authorized() {
      return this.$store.getters.authorized;
    },
  },
  watch: {
    show() {
      this.email = "";
      this.password = "";
      this.errorMessage = null;
      if (this.$refs.observer) this.$refs.observer.reset();
    },
    authorized(val) {
      this.show = !val;
    },
  },
  methods: {
    async onSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      this.loading = true;

      this.$store
        .dispatch("login", {
          email: this.email,
          password: this.password,
        })
        .then(
          () => {
            // Do nothing, store will handle state changes.
          },
          (error) => {
            if (error.statusCode === 400) {
              this.errorMessage = error.result["authorization"][0];
            } else {
              this.$store.dispatch(
                "notifications/error",
                "An unexpected error occurred while trying to login. Please try again later."
              );
            }
          }
        )
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.show = !this.authorized;
  },
};
</script>
